import { useState } from 'react';

import { message } from 'antd';

import { OtherEntityType, SelectedTabItem } from '@components/common/searchTabs/common/types';

import { saveOtherEntity } from '../api';

const MIN_SEARCH_LENGTH_FOR_ADD = 3;

const OTHER_ENTITY_SUCCESS_MESSAGE: Record<OtherEntityType, string> = {
    services: 'Услуга добавлена в прочее',
    products: 'Товар добавлен в прочее',
    tasks: 'Задача добавлена в прочее',
};

export interface TSearchResultItem {
    type: string;
    data: { id: number; name: string; price: number; duration?: number };
}

interface UseQuickAddEntityParams {
    searchValue: string;
    isBusy: boolean;
    crmId: number | undefined;
    getEntitiesByType: (entityType: OtherEntityType) => TSearchResultItem[] | undefined;
    onSelectExisting: (item: SelectedTabItem, key: OtherEntityType) => void;
    onEntityCreated: (entityType: OtherEntityType, item: SelectedTabItem) => void;
}

export const useQuickAddEntity = ({
    searchValue,
    isBusy,
    crmId,
    getEntitiesByType,
    onSelectExisting,
    onEntityCreated,
}: UseQuickAddEntityParams) => {
    const [addingEntityType, setAddingEntityType] = useState<OtherEntityType | null>(null);

    const canAddEntity = searchValue.trim().length >= MIN_SEARCH_LENGTH_FOR_ADD && !isBusy;

    const handleAddOrSelectEntity = async (entityType: OtherEntityType) => {
        if (!canAddEntity || addingEntityType) return;

        const normalizedSearch = searchValue.trim().toLowerCase();
        const existingItem = getEntitiesByType(entityType)?.find(
            (item) => item?.data?.name?.trim().toLowerCase() === normalizedSearch
        );

        if (existingItem) {
            onSelectExisting(
                {
                    id: existingItem.data.id,
                    type: existingItem.type,
                    name: existingItem.data.name,
                    price: existingItem.data.price,
                    quantity: 1,
                    duration: existingItem.data.duration,
                },
                entityType
            );
            return;
        }

        setAddingEntityType(entityType);
        try {
            const created = await saveOtherEntity(entityType, { crm_id: crmId, name: searchValue });
            message.success(OTHER_ENTITY_SUCCESS_MESSAGE[entityType]);
            onEntityCreated(entityType, created);
        } catch (error) {
            console.error(`Failed to save ${entityType} item:`, error);
            message.error(`Не удалось сохранить ${entityType} элемент`);
        } finally {
            setAddingEntityType(null);
        }
    };

    return { canAddEntity, addingEntityType, handleAddOrSelectEntity };
};
